



















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateEquipmentmodel from "./create-equipmentmodel.vue";
import EditEquipmentmodel from "./edit-equipmentmodel.vue";
 
let ispartysrc= require("@/images/danghui.png");

class PageBHUserRequest extends PageRequest {
    Keyword: string;
    wyid:number;
    wcid:number;
    efid:number;
 
}

 @Component({
        components:{CreateEquipmentmodel,EditEquipmentmodel}
    })
export default class Equipmentmodel extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageBHUserRequest = new PageBHUserRequest();
   

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
                   
    return this.$store.state.equipmentmodel.list;
  }
  get loading() {
    return this.$store.state.equipmentmodel.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("equipmentmodel/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("equipmentmodel/setPageSize", pagesize);
    this.getpage();
  }
  
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "equipmentmodel/getAll",
      data: this.pagerequest,
    });
  }
     
  get pageSize() {
    return this.$store.state.equipmentmodel.pageSize;
  }
  get totalCount() {
    return this.$store.state.equipmentmodel.totalCount;
  }
  get currentPage() {
    return this.$store.state.equipmentmodel.currentPage;
  }
   get wastecodenowlist(){
          return  this.$store.state.equipmentmodel.wastecodenowlist;
        }
          set  wastecodenowlist(val){
           this.$store.commit('equipmentmodel/change_wastecategory',val);
        }   
   
     change_wastecategory(val){
            
            var wcnowlist=[];
            var wclist=   this.$store.state.equipmentmodel.wastecodelist;
            wclist.forEach(item => {
                if(item.wastecategoryid==val){
                    wcnowlist.push(item)
                }
            });
              this.wastecodenowlist=wcnowlist;
        }
        
 
  columns = [
    /*{
      
      title: this.L("ID"),
      key: "id",
      width: 80,
    },*/
     {
      
      title: this.L("型号名称"),
      key: "modelname",
       
    },
     {
      
      title: this.L("贮运容器编码"),
      key: "containercoding",
      width: 120,
    },
      
      
    {
      
      title: this.L("电量预警值（°）"),
      key: "electricitywarningvalue",
      
    },
       {
      
      title: this.L("温度预警值(℃)"),
      key: "temperaturewarningvalue",
   
    },
         {
      
      title: this.L("重量预警值(kg)"),
      key: "weightwarningvalue",
      
    },
        {
      
      title: this.L("减量预警值(kg)"),
      key: "reductionwarningvalue",
      
    },
        {
      
      title: this.L("位移预警值(m)"),
      key: "displacementwarningvalue",
       
    },
      
       {
      
      title: this.L("无废间隔预警值(月)"),
      key: "nowasteintervalwarningvalue",
     
    },
        {
      
      title: this.L("数据心跳间隔(h)"),
      key: "dataheartbeatinterval",
      
    },

     
  /* {
   title: this.L("审批状态"),
       width: 100,
      render: (h: any, params: any) => {
        return h("span", params.row.status==true ? this.L("已审批") : this.L("未审批"));
      },
   },*/
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      render: (h: any, params: any) => {
        var listbtn=[
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("equipmentmodel/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("编辑")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
               style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteDataConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "equipmentmodel/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]
       /*  if(!params.row.status){
           listbtn.push(h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              }, style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("UpdateDataApprovedConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "equipmentmodel/updatestatus",
                        data: {hid:params.row.id},
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("审批"))  //updatestatus
          ,)

        }*/
        return h("div",listbtn );
      },
    },
  ];
  async created() {
    this.getWastecategoryAll();
    this.getpage();
    this.getWastecodeAll();
   
  }

  async  getWastecategoryAll() {
     await this.$store.dispatch({
      type: "equipmentmodel/getWastecategoryAll",
      data: {status:0},
    });
  }
    async  getWastecodeAll() {
     await this.$store.dispatch({
      type: "equipmentmodel/getWastecodeAll",
      data: {status:0},
    });
  }
   

    getPhysicalcharacteristicsTxt(id){
        var txt="";
       var physicalcharacteristics=  this.$store.state.equipmentmodel.physicalcharacteristics;
       physicalcharacteristics.forEach(item=>{
             if(item.id==id){
               txt= item.name;
               return txt;
             }

       })
       
     return txt;
    }
    


   


 //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "equipmentmodel/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
                   
				
					lt.map((item) => { // 这里修改要下载的字段内容
					  /*item.status == false ? item.status = '否' : item.status == true ?  item.status ='是' : item.status ='否';
                      item.status==true ? item.status = '已审批' :'未审批';
                      var statustime="";
                    if(item.statustime!=null){
                          statustime= new Date(item.statustime).toLocaleString();
                       }	
                   if(statustime=="1/1/1 00:00:00"){
                      statustime="";
                    }
                    item.statustime=statustime;*/

                   var storagepointtypelist=   this.$store.state.equipmentmodel.storagepointtype
                    storagepointtypelist.forEach(x=>{
                    if(x.id== item.storagepointtype){
                        item.storagepointtype=x.name;
                    }})
                   //  item.sizeunits="";
                    var sizeunitslist=   this.$store.state.equipmentmodel.sizeunits
                    sizeunitslist.forEach(x=>{
                    if(x.id== item.sizeunits){
                        item.sizeunits=x.name;
                    }})

                     var containertypelist=   this.$store.state.equipmentmodel.containertype
                    containertypelist.forEach(x=>{
                    if(x.id== item.containertype){
                        item.containertype=x.name;
                    }})
                  var containercapacitylist=   this.$store.state.equipmentmodel.containercapacity
                    containercapacitylist.forEach(x=>{
                    if(x.id== item.containercapacity){
                        item.containercapacity=x.name;
                    }})
                    var containermateriallist=   this.$store.state.equipmentmodel.containermaterial
                    containermateriallist.forEach(x=>{
                    if(x.id== item.containermaterial){
                        item.containermaterial=x.name;
                    }})

                 var capacityunitlist=   this.$store.state.equipmentmodel.capacityunit
                    capacityunitlist.forEach(x=>{
                    if(x.id== item.capacityunit){
                        item.capacityunit=x.name;
                    }})
               

					  return item;
					});
 
 
 
                 console.log(lt)
 
   
  
  
    
           //    return false
 
 
    
                    
    
					const filterVal = ['id', 'modelname','containercoding','containertype','containercapacity','containermaterial','storagepointtype','sizeunits','storagesize','capacityunit','storagecapacity','storagecapacity','temperaturewarningvalue','weightwarningvalue','reductionwarningvalue','displacementwarningvalue','nowasteintervalwarningvalue','dataheartbeatinterval'];// 取出要下载的表头字段
					const tHeader = ['ID','型号名称','贮运容器编码','容器类型','容器容量','容器材质','贮存点类型','贮存点大小单位','贮存点大小','贮存能力单位','贮存能力','电量预警值','温度预警值','重量预警值','减量预警值','位移预警值(m)','无废间隔预警值(月)','数据心跳间隔(h)'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '设备型号');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

			
}
